var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeSpent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "temps-passe",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.496,
    height: 15.496,
    viewBox: "0 0 15.496 15.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2629",
    "data-name": "Trac\\xE9 2629",
    d: "M7.748,0A7.73,7.73,0,0,0,2.583,1.984V.646a.646.646,0,0,0-1.291,0V2.583A1.937,1.937,0,0,0,3.228,4.52H5.165a.646.646,0,0,0,0-1.291H3.228a.551.551,0,0,1-.065-.014A6.448,6.448,0,1,1,1.291,7.748.646.646,0,0,0,0,7.748,7.748,7.748,0,1,0,7.748,0Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2630",
    "data-name": "Trac\\xE9 2630",
    d: "M11.646,6A.646.646,0,0,0,11,6.646V9.874a.646.646,0,0,0,.189.456l1.937,1.937a.646.646,0,1,0,.913-.913L12.291,9.607V6.646A.646.646,0,0,0,11.646,6Z",
    transform: "translate(-3.898 -2.126)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSpent);
export default __webpack_public_path__ + "static/media/time_spent.3287fa87af31720c9c5549ac4579b33f.svg";
export { ForwardRef as ReactComponent };